var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-slider",class:{
    'slider-5-elems': _vm.customSliderValues.length - 1 === 5,
    'slider-4-elems': _vm.customSliderValues.length - 1 === 4,
    'slider-3-elems': _vm.customSliderValues.length - 1 === 3,
    'slider-2-elems': _vm.customSliderValues.length - 1 === 2,
    'slider-1-elems': _vm.customSliderValues.length - 1 === 1
  }},[_c('vue-slider',{attrs:{"height":50,"min":0,"max":100,"interval":1,"tooltip":"none","min-range":5,"drag-on-click":false,"disabled":_vm.customSliderValues.length <= 2,"process":_vm.customSliderProcess},on:{"change":function($event){return _vm.updateCustomValues($event)},"dragging":function($event){return _vm.updateCustomValues($event)}},scopedSlots:_vm._u([{key:"process",fn:function(ref){
  var start = ref.start;
  var end = ref.end;
  var style = ref.style;
  var index = ref.index;
return [_c('div',{staticClass:"vue-slider-process",style:(style)},[_c('div',{class:[
            'merge-tooltip',
            'vue-slider-dot-tooltip-inner',
            'vue-slider-dot-tooltip-inner-top'
          ]},[_vm._v("\n          "+_vm._s(Math.round(
              _vm.customSliderValues[index + 1] - _vm.customSliderValues[index]
            ))+"%\n        ")])])]}}]),model:{value:(_vm.customSliderValues),callback:function ($$v) {_vm.customSliderValues=$$v},expression:"customSliderValues"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }